<!--
 * @Author: your name
 * @Date: 2021-07-22 15:47:49
 * @LastEditTime: 2021-08-24 11:13:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/views/pages/strategyPlatform/preSale.vue
-->
<template>
  <div class="preSale">
    <div class="preSale-list" v-for="(li, index) in datalist" :key="index">
      <div class="preSale-lable">
        <span>*</span>
        {{t('预售识别规则')}}：
      </div>
      <Select
        v-model="li.PRESELL_DISCERN_TYPE"
        style="width: 100px"
        @on-change="change(li.PRESELL_DISCERN_TYPE, li)"
      >
        <Option
          v-for="item in li.slectList"
          :value="item.value"
          :key="item.value"
          >{{ item.label }}</Option
        >
      </Select>
      <div class="preSale-center" v-show="li.show">
        <Input
          v-model="li.PRESELL_DISCERN_CENTENT"
          :placeholder="li.placeholder"
          style="width: 250px"
        />

        <div class="preSale-lable">
          <span>*</span>
          {{t('预计发货时间')}}：
        </div>

         <Select v-model="li.PREDICT_TYPE" style="width:200px" @on-change="fnselect">
            <Option v-for="item in li.valueList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <div class="preSale-lable" v-show="li.PREDICT_TYPE == 1">
           <DatePicker
            type="datetime"
            :placeholder="t('固定时间')"
            style="width: 200px"
            :value="li.PREDICT_DELIVER_GOODS_TIME"
            @on-change="fndatachange($event, li)"
          ></DatePicker>
        </div>
         <div class="preSale-lable" v-show="li.PREDICT_TYPE == 2">
           <Input v-model="li.DAY_NUM" style="width: 100px" />
           {{t('天')}}
        </div>
        <div class="preSale-text" v-show="index != 0">
           {{t('或')}}
        </div>
        <div class="preSale-add" v-show="index == indexlenth">
          <Icon type="md-add" color="#ed4014" @click="add"  size="24" />
          <Icon type="md-remove" color="#ed4014" @click="fndel(index)" size="24"  v-if="index != 0"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '@/service/index';

export default {
  data() {
    return {
      indexlenth: 0,
      dataobj: {
        PRESELL_DISCERN_TYPE: '',
        PRESELL_DISCERN_CENTENT: '',
        DAY_NUM: '',
        placeholder: t('商品标题/规格名称中可用特殊符号和文字'),
        show: false,
        icon: true,
        valueList: [
          {
             label: t('固定时间'),
             value: 1,
          },
          {
             label: t('付款后'),
             value: 2,
          }
        ],
        PREDICT_TYPE: '',
        PREDICT_DELIVER_GOODS_TIME: '', //预计发货时间
        slectList: [
          {
            label: t('自定义关键字'),
            value: 1,
          },
          {
           label: t('清空明细'),
           value: 2,
          },
          {
           label: t('平台商品ID'),
           value: 3,
          },
          {
            label: t('系统SKU编码'),
            value: 4,
          },
          {
            label: t('系统SPU编码'),
            value: 5,
          },
        ],
      },
      datalist: [],
    };
  },
  created() {},
  beforeDestroy() {
    window.removeEventListener('customizeClick', this.Save);
  },
  mounted() {
    window.addEventListener('customizeClick', this.Save);
    //先清理页面
    this.$nextTick(() => {
      $('.preSale').parent().parent().find('.itemLabel').remove();
    });
    if (this.$route.params.itemId != 'New') {
      this.init();
    } else {
      this.datalist.push(this.dataobj);
    }
  },
  methods: {
    fnselect(v){
console.log(v);
    },
    fndel(i){
        this.datalist.splice(i,1)
        this.indexlenth = this.datalist.length - 1;
    },
    Save(data) {
      if (data.detail.type == 'save') {
        let reqdata = [];
        this.datalist.forEach((item) => {
          let obj = {
            ID:
              this.$route.params.itemId == 'New'
                ? '-1'
                : this.$route.params.itemId,
            PRESELL_DISCERN_TYPE: item.PRESELL_DISCERN_TYPE,
            PRESELL_DISCERN_CENTENT: item.PRESELL_DISCERN_CENTENT,
            PREDICT_TYPE: item.PREDICT_TYPE,
            PREDICT_DELIVER_GOODS_TIME: item.PREDICT_DELIVER_GOODS_TIME,
            DAY_NUM: item.DAY_NUM,
          };
          reqdata.push(obj);
        });

        this.$emit('change', reqdata);
      }
    },
    keyDown() {},
    add() {
      this.datalist.push(JSON.parse(JSON.stringify(this.dataobj)));
      this.indexlenth = this.datalist.length - 1;
    },
 
    fndatachange(data, en) {
      en.PREDICT_DELIVER_GOODS_TIME = data;
    },
    change(v, en) {
      en.show = true;
      if (v > 1) {
       // en.placeholder = '请输入识别内容，多关键字使用中文“，”隔开';
       en.placeholder = t('请输入识别内容，多关键字使用中文“，”隔开');
      } else {
        // en.placeholder = '商品标题/规格名称中可用特殊符号和文字';
         en.placeholder = t('商品标题/规格名称中可用特殊符号和文字');
      }
    },
    init() {
      let data = {
        ID: this.$route.params.itemId,
      };
      service.strategyPlatform.selItemByMainId(data).then((res) => {
        if (res.data.code == 0) {
          let data =
            res.data.data.ST_C_CUSTOM_PRESELL_STRATEGY
              .ST_C_CUSTOM_PRESELL_STRATEGY_ITEM;

          data.forEach((item) => {
            for (const k in item) {
              this.dataobj[k] = item[k];
            }
            this.dataobj.show = true;
            let newdata = new Date(item.PREDICT_DELIVER_GOODS_TIME);
            this.dataobj.PREDICT_DELIVER_GOODS_TIME = $utils.dateFormat(
              newdata,
              'yyyy-MM-dd hh:mm:ss'
            );
        
            this.datalist.push(JSON.parse(JSON.stringify(this.dataobj)));
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.preSale {
  .preSale-list {
    display: flex;
    align-items: center;
    padding: 15px;
    .preSale-center {
      display: flex;
      align-items: center;
      .ark-input-wrapper{
        margin-left: 10px;
      }
    }
    .preSale-lable {
      padding: 0 5px;
      span {
        color: red;
      }
    }
    .preSale-add {
      margin-left: 10px;
    }
    .ark-radio-group {
      display: flex;
      align-items: center;
    }
    .preSale-text{
      position: relative;
      top: -30px;
    }
  }
}
</style>
